import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Config from '../config/config';
import { isTablet, getProductCategoryIds, getParentCategoryId } from '../lib/util';
import './CatalogProductGrid.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';

class CatalogProductGrid extends Component {
  getActiveCategoryIds(id) {
    const { categories } = this.props;

    const poolArr = categories.filter(elem => getParentCategoryId(elem) === id * 1);
    if (poolArr.length === 0) {
      return [id * 1];
    }
    let temp = [id * 1];
    poolArr.forEach((elem) => {
      temp = temp.concat(this.getActiveCategoryIds(elem.category_ID));
    });
    return temp;
  }

  render() {
    const pathNameArr = this.props.location.pathname.split('/');
    const activeCategoryIds = this.getActiveCategoryIds(pathNameArr[pathNameArr.length - 1]);
    const columns = this.props.products.map((elem) => {
      const productCategoryIds = getProductCategoryIds(elem);
      const inActiveCategoryIds = activeCategoryIds.filter((activeCategoryId) => productCategoryIds.indexOf(activeCategoryId) !== -1);

      if (inActiveCategoryIds.length === 0) {
        return null;
      }

      let coverImage;
      if(elem.image.length > 0){
        coverImage = elem.image[0];
      }

      const activeCategory = elem.categories.filter(category => inActiveCategoryIds.indexOf(category.category_ID) !== -1)[0];
      const tag = activeCategory.title;

      // const isFadeIn = activeCategoryIds.indexOf(elem.category_ID) !== -1;
      return (
        <CSSTransition timeout={300} key={elem._id} classNames="animation">
          <div className={`column ${isTablet() ? 'is-one-third' : 'is-one-third'}`}>
            <div className="product">
              <Link
                to={elem.product_ID ? `/product/${elem.product_ID}?category=${activeCategory.category_ID}` : '/product/1'}
                data-title={elem.title}
              >
                <div className="product-image-wrapper">
                  <div
                    className="product-image"
                    style={{
                      backgroundImage:
                        coverImage
                          ? `url(${Config.apiUrl}${coverImage.url})`
                          : 'url("http://via.placeholder.com/250x250")',
                    }}
                  />
                </div>
                <div className="product-description">
                  
                  <div className="product-description-title">
                    <p>
                      <FontAwesomeIcon className="title-icon" icon={faAngleRight} />
                      <span className="eng_title">{elem.title}</span>
                    </p>
                    <p className="chinese_title">{elem.chinese_title}</p>
                  </div>
                </div>
                {tag && 
                  <div className="product-tag">
                    <span>{tag}</span>
                  </div>
                }
              </Link>
            </div>
          </div>
        </CSSTransition>
      );
    });
    return (
      <TransitionGroup className="columns is-multiline product-grid" appear>
        {columns}
      </TransitionGroup>
    );
  }
}

CatalogProductGrid.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

CatalogProductGrid.defaultProps = {
  location: {
    pathname: '/catalog',
  },
};

export default CatalogProductGrid;



// WEBPACK FOOTER //
// ./src/components/CatalogProductGrid.js